module.exports = "../../app/cells/components/subproduct_landings/offer_section_cell.rb";